import { useTranslation } from "react-i18next"
import { Rnd } from "react-rnd"

interface VideoPopupProps {
	id: string
	onClose: (id: string) => void
	height: number | string
	width: number | string
	type?: string
}

const VideoPopup = ({ id, onClose, height, width, type = "youtube" }: VideoPopupProps) => {
	const { t } = useTranslation()
	const halfWidth = width === "60%" ? (window.innerWidth * 0.6) / 2 : Number(width) / 2
	const halfHeight = height === "60%" ? (window.scrollY * 0.6) / 2 : Number(height) / 2

	return (
		<Rnd
			default={{
				width,
				height,
				x: window.innerWidth / 2 - halfWidth,
				y: window.scrollY + window.innerHeight / 2 - halfHeight,
			}}
			style={{ zIndex: 4000 }}
			bounds="window"
		>
			<div style={{ position: "relative", height: "100%", backgroundColor: "rgba(0, 80, 154, 0.61)" }}>
				<div style={{ height: 30, width: "100%" }}></div>
				<button
					onClick={() => onClose(id)}
					style={{
						position: "absolute",
						top: 0,
						right: 0,
						background: "rgba(0, 80, 154, 0.61)",
						color: "white",
						border: "none",
						padding: "5px",
						cursor: "pointer",
						height: 30,
						width: 20,
					}}
				>
					X
				</button>
				{type === "youtube" && (
					<iframe
						width="100%"
						height="100%"
						src={`https://www.youtube.com/embed/${id}`}
						allowFullScreen
						id="iframe-panel"
					></iframe>
				)}
				{type === "local" && (
					<video width="100%" height="100%" controls>
						<source src={`/videos/${id}`} type="video/mp4" />
						{t("Sinun selaimesi ei tue video tagia")}.
					</video>
				)}
			</div>
		</Rnd>
	)
}

export default VideoPopup
